/**
 * swiper slider start up for components like  the side by side content + featured collections
 */

window.addEventListener("load", (e) => {
	const sliderContainers = [
		...document.querySelectorAll("[swiper-slider]"),
	];
	if (sliderContainers.length !== 0) {
		sliderContainers.forEach((sliderContainer) => {
			const slider = sliderContainer.querySelector("[data-slider]");
			const sliderType = slider.dataset.type;
			const sliderLeftBtn = sliderContainer.querySelector(
				"[data-swiper-previous]"
			);
			const sliderRightBtn =
				sliderContainer.querySelector("[data-swiper-next]");
			let options = {
				keyboard: true,
				pagination: {
					el: ".slider-pagination",
					bulletClass: "slider-pagination__button",
					bulletActiveClass: "slider-pagination__button--active",
					clickable: true,
				},
				navigation: {
					nextEl: sliderRightBtn,
					prevEl: sliderLeftBtn,
				},
				a11y: true,
				watchOverflow: true,
				watchSlidesProgress: true,
			};

			if (sliderType == "content-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: true,
					effect: "fade",
					fadeEffect: { crossFade: true },
				};
			}

			if (sliderType == "collections-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: true,
					speed: 600,

					breakpoints: {
						600: {
							slidesPerView: 2,
							spaceBetween: 50,
						},
						1200: { 
							slidesPerView: 2,
							spaceBetween: 158
						}

					}
				};
			}

			if (sliderType == "content-img-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: true,
					effect: "fade",
					fadeEffect: { crossFade: true },
				};
			}

			if (sliderType == "content-text-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: true,
					effect: "fade",
					fadeEffect: { crossFade: true },
					variableWidth: true
				};
			}



			const swiper = new Swiper(slider, options);
			const sliderAnnouncer = sliderContainer.querySelector(
				".swiper-notification"
			);
			setupVisibileSlides();

			// remove role="group" from li slide elements
			const liSlides = [...slider.querySelectorAll('[data-slider-item]')]
			liSlides.forEach(slide => slide.removeAttribute('role'))

			// Announce new slide to screen reader users -- multiple slider per view
			if (sliderType == "content-slider" || sliderType == "collections-slider") {

				[sliderLeftBtn, sliderRightBtn].forEach((sliderBtn) => {

					sliderBtn.addEventListener('click', e => {
						const activeSlides = [...slider.querySelectorAll('.swiper-slide-visible')];
						const firstActiveSlide = activeSlides[0];
						const lastActiveSlide = activeSlides[activeSlides.length - 1];
						const activeSlideIndexStart = firstActiveSlide.getAttribute('aria-label').replace(/(^\d+)(.+$)/i, '$1');
						const activeSlideIndexEnd = lastActiveSlide.getAttribute('aria-label').replace(/(^\d+)(.+$)/i, '$1');

						sliderAnnouncer.textContent = `now showing slides ${activeSlideIndexStart} through ${activeSlideIndexEnd}`

						setupVisibileSlides()
					})
				});
			}
			// removes aria-hidden = true and tabindex for slides that are visible (voiceover ada)
			function setupVisibileSlides() {
				const sliderItems = [...slider.querySelectorAll('[data-slider-item]')];
				sliderItems.forEach(sliderItem => {
					if (sliderItem.classList.contains("swiper-slide-visible")) {
						sliderItem.removeAttribute('aria-hidden');
						sliderItem.removeAttribute('tabindex');
						sliderItem.querySelectorAll('a').forEach(anchor => anchor.removeAttribute('tabindex'));
					}
					else {
						sliderItem.setAttribute('aria-hidden', "true");
						sliderItem.setAttribute('tabindex', "-1");
						sliderItem.querySelectorAll('a').forEach(anchor => anchor.setAttribute('tabindex', "-1"));
					}
				})
			}
		});

		const imgSlider = document.querySelector('[data-type="content-img-slider"]').swiper;
		const textSlider = document.querySelector('[data-type="content-text-slider"]').swiper;

		if (imgSlider && textSlider) {
			textSlider.controller.control = imgSlider
			imgSlider.controller.control = textSlider
		}
	}
});
